import { USER_ROLE } from '../user/types';

export interface IUserTokens {
  token: string;
  refreshToken: string;
}
export interface IUserStorage extends IUserTokens {
  roles: USER_ROLE[];
  userId: string;
  username: string;
  persist: boolean;
}

const getStore = (persist: boolean) => {
  return persist ? localStorage : sessionStorage;
};

export const storeUser = (user: IUserStorage) => {
  const store = getStore(user.persist);
  store.setItem('user', JSON.stringify(user));
};

export const retrieveUser = () => {
  const fromStorage =
    localStorage.getItem('user') || sessionStorage.getItem('user');
  return fromStorage ? (JSON.parse(fromStorage) as IUserStorage) : null;
};

export const forgetUser = () => {
  localStorage.removeItem('user');
  sessionStorage.removeItem('user');
};

export const updateTokens = (tokens: IUserTokens) => {
  const user = retrieveUser();
  if (user) {
    storeUser({
      ...user,
      ...tokens,
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/storage/user.ts